import { render, staticRenderFns } from "./ilmoitus-form.vue?vue&type=template&id=2409aa13&scoped=true&"
import script from "./ilmoitus-form.vue?vue&type=script&lang=ts&"
export * from "./ilmoitus-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2409aa13",
  null
  
)

export default component.exports